/* SmartHome-Energy – Versandkosten-Box + Mindestbestellmenge  (21.09.2026)
 *
 * Drei Aufgaben:
 *  1) Versand-Box auf der Produktseite mit der gewaehlten Variante synchron halten
 *     (Markup: snippets/she-versand-box.liquid, Tarife: snippets/she-versand-daten.liquid)
 *  2) Mindestbestellmenge am Mengenfeld und beim Add-to-Cart durchsetzen
 *  3) Mindestbestellmenge im Warenkorb pruefen und den Checkout sperren
 *
 * Selbst-guardend: ohne Versand-Box bzw. ohne Mindestmenge passiert nichts.
 */
(function () {
  'use strict';

  var EUR = function (v) { return String(v).replace('.', ','); };

  /* ---------------------------------------------------------------- 1) Box */

  function initBox() {
    var box = document.querySelector('[data-she-versand]');
    if (!box || box.__she) return null;
    box.__she = 1;

    var rates = {};
    try { rates = JSON.parse(box.dataset.rates); } catch (e) { return null; }

    var spedAb = parseInt(box.dataset.speditionAb, 10) || 0;
    var budFrei = parseInt(box.dataset.budmatFrei, 10) || 0;
    var klasse = box.dataset.klasse || 'komponenten';
    var main = box.querySelector('[data-she-versand-main]');
    var sub = box.querySelector('[data-she-versand-sub]');
    var minHint = box.querySelector('[data-she-min-hint]');

    function render(id) {
      var r = rates[id];
      if (!r) return;

      if (!r.t) {
        main.textContent = 'Versandkosten auf Anfrage';
        sub.textContent = r.s || '';
      } else {
        main.textContent = 'Versand ' + EUR(r.t) + ' € innerhalb Österreich';
        var teile = [];
        if (r.s) teile.push(r.s);
        if (klasse.indexOf('budmat') === 0 && budFrei) {
          teile.push('ab ' + budFrei.toLocaleString('de-AT') + ' € Warenwert kostenlos');
        }
        if (spedAb && r.kg >= spedAb) {
          teile.push('Spedition, Anlieferung frei Bordsteinkante');
        }
        sub.textContent = teile.join(' · ');
      }

      if (minHint) {
        if (r.min > 1) {
          minHint.textContent = 'Mindestbestellmenge: ' + r.min + ' Stück. Kleinere Mengen'
            + ' können wir nicht liefern – sprich uns gerne an.';
          minHint.hidden = false;
        } else {
          minHint.hidden = true;
        }
      }
    }

    return { rates: rates, render: render };
  }

  /* ------------------------------------------------- 2) Mindestmenge (PDP) */

  /* Die Produktseiten dieses Themes enthalten mehrere Formulare mit
   * action="/cart/add". Massgeblich ist das, das ein Mengenfeld hat. */
  function atcForm() {
    var qty = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    if (qty && qty.form) return qty.form;
    if (qty) return qty.closest('form');
    return document.querySelector('form[action*="/cart/add"]');
  }

  function currentVariantId() {
    var form = atcForm();
    var input = form && form.querySelector('input[name="id"]');
    if (!input) input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  function applyMin(rates) {
    var form = atcForm();
    if (!form || !rates) return;
    var id = currentVariantId();
    var r = id && rates[id];
    var min = r && r.min > 1 ? r.min : 1;

    var qty = form.querySelector('input[name="quantity"]');
    if (qty) {
      var prevMin = parseInt(form.dataset.sheLastMin, 10) || 1;
      var val = parseInt(qty.value, 10) || 1;

      qty.setAttribute('min', min);
      qty.setAttribute('step', min > 1 ? min : 1);

      if (val < min) {
        qty.value = min;
      } else if (val === prevMin && prevMin !== min) {
        /* Der Kunde hatte die vorherige Mindestmenge stehen, hat also nicht
         * selbst getippt – beim Variantenwechsel auf die neue Menge setzen. */
        qty.value = min;
      }
      form.dataset.sheLastMin = min;
    }

    /* Mindestmenge als verstecktes Line-Item-Property mitgeben, damit der
     * Warenkorb sie kennt, ohne das Produkt erneut laden zu muessen. */
    var prop = form.querySelector('input[name="properties[_mindestmenge]"]');
    if (min > 1) {
      if (!prop) {
        prop = document.createElement('input');
        prop.type = 'hidden';
        prop.name = 'properties[_mindestmenge]';
        form.appendChild(prop);
      }
      prop.value = min;
    } else if (prop) {
      prop.remove();
    }
  }

  function guardSubmit(rates) {
    var form = atcForm();
    if (!form || form.__sheGuard || !rates) return;
    form.__sheGuard = 1;

    form.addEventListener('submit', function (ev) {
      var id = currentVariantId();
      var r = id && rates[id];
      if (!r || r.min <= 1) return;
      var qty = form.querySelector('input[name="quantity"]');
      var val = qty ? parseInt(qty.value, 10) || 1 : 1;
      if (val < r.min) {
        ev.preventDefault();
        ev.stopPropagation();
        if (qty) { qty.value = r.min; qty.focus(); }
        var hint = document.querySelector('[data-she-min-hint]');
        if (hint) {
          hint.hidden = false;
          hint.style.outline = '2px solid #e6b800';
          setTimeout(function () { hint.style.outline = ''; }, 1600);
        }
      }
    }, true);
  }

  /* ------------------------------------------- 3) Mindestmenge (Warenkorb) */

  var lastBad = [];
  var checkTimer = null;   /* nur fuer checkCart  */
  var applyTimer = null;   /* nur fuer applyBlock */

  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], [name="checkout"]';
  var EXPRESS_SEL = '.shopify-payment-button, [data-shopify="payment-button"], '
    + '.dynamic-checkout__content, shopify-accelerated-checkout, shopify-accelerated-checkout-cart';

  function checkCart() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastBad = (cart.items || []).filter(function (it) {
          var m = it.properties && it.properties._mindestmenge;
          return m && it.quantity < parseInt(m, 10);
        });
        applyBlock();
      })
      .catch(function () { /* still */ });
  }

  function scheduleCheck(delay) {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkCart, delay || 150);
  }

  /* Setzt Warnung und Sperre. Wird auch nach jedem Re-Rendering der
   * Cart-Section erneut aufgerufen, weil Shopify dabei die Buttons
   * austauscht und ein gesetztes disabled verloren geht. */
  function applyBlock() {
    var blocked = lastBad.length > 0;

    document.querySelectorAll(CHECKOUT_SEL).forEach(function (b) {
      if (blocked) {
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('aria-disabled', 'true');
      } else if (b.dataset.sheBlocked || b.hasAttribute('disabled')) {
        /* Nur wieder freigeben, was wir selbst gesperrt haben. */
        if (b.dataset.sheBlocked) b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
      }
      if (blocked) { b.dataset.sheBlocked = '1'; } else { delete b.dataset.sheBlocked; }
    });

    /* Express-Checkout (Shop Pay, PayPal, Google Pay) mit sperren – sonst
     * laesst sich die Mindestmenge einfach umgehen. */
    document.querySelectorAll(EXPRESS_SEL).forEach(function (el) {
      if (blocked) {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.4';
        el.setAttribute('aria-disabled', 'true');
        el.dataset.sheBlocked = '1';
      } else if (el.dataset.sheBlocked) {
        el.style.pointerEvents = '';
        el.style.opacity = '';
        el.removeAttribute('aria-disabled');
        delete el.dataset.sheBlocked;
      }
    });

    renderWarning(blocked);
  }

  function renderWarning(blocked) {
    var old = document.getElementById('she-min-warn');

    if (!blocked) { if (old) old.remove(); return; }

    var html = '<strong>Mindestbestellmenge nicht erreicht</strong><br>'
      + lastBad.map(function (it) {
          return it.product_title + ': ' + it.quantity + ' statt mindestens '
            + it.properties._mindestmenge + ' Stück';
        }).join('<br>')
      + '<br>Bitte die Menge anpassen – oder <a href="/pages/contact"'
      + ' style="color:#ff6600;font-weight:600">frag uns nach einer Sondermenge</a>.';

    if (old) {
      if (old.dataset.sheHtml !== html) { old.innerHTML = html; old.dataset.sheHtml = html; }
      return;
    }

    var box = document.createElement('div');
    box.id = 'she-min-warn';
    box.setAttribute('role', 'alert');
    box.dataset.sheHtml = html;
    box.style.cssText = 'margin:14px 0;padding:12px 14px;border-radius:10px;background:#fbf4dd;'
      + 'color:#7a6200;font-size:14px;line-height:1.55;border:1px solid #f0e3b8';
    box.innerHTML = html;

    var anchor = document.querySelector(CHECKOUT_SEL);
    if (anchor && anchor.parentElement) {
      anchor.parentElement.insertBefore(box, anchor);
      return;
    }
    /* Ohne Checkout-Button ist die Seite kein Warenkorb – dort waere die
     * Warnung nur Laerm (sie erschiene sonst auf jeder Produktseite).
     * Der Fallback greift nur auf der Warenkorbseite selbst, damit nichts
     * unsichtbar im geschlossenen Cart-Drawer landet. */
    if (!/\/cart/.test(location.pathname)) return;
    var fallback = document.querySelector('.cart__footer, .cart-summary, form[action="/cart"]');
    if (fallback) fallback.prepend(box);
  }

  /* Das Theme feuert kein verlaessliches Cart-Event. Deshalb drei Wege:
   * fetch-/XHR-Aufrufe auf die Cart-Endpunkte mitlesen und eine
   * MutationObserver-Absicherung fuer das Re-Rendering der Cart-Section. */
  function watchCart() {
    var isCartUrl = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };

    try {
      var of = window.fetch;
      if (of && !window.__sheFetchPatched) {
        var patched = function () {
          var url = arguments[0];
          if (url && typeof url === 'object' && url.url) url = url.url;
          var p = of.apply(this, arguments);
          if (isCartUrl(url) && p && p.then) {
            p.then(function () { scheduleCheck(200); }, function () {});
          }
          return p;
        };
        patched.__she = 1;
        window.fetch = patched;
        window.__sheFetchPatched = 1;
      }
    } catch (e) { /* still */ }

    try {
      var oo = XMLHttpRequest.prototype.open;
      if (oo && !window.__sheXhrPatched) {
        var openPatched = function (method, url) {
          if (isCartUrl(url)) {
            this.addEventListener('loadend', function () { scheduleCheck(200); });
          }
          return oo.apply(this, arguments);
        };
        openPatched.__she = 1;
        XMLHttpRequest.prototype.open = openPatched;
        window.__sheXhrPatched = 1;
      }
    } catch (e) { /* still */ }

    /* Absicherung: wenn das Theme die Cart-Section neu rendert, sind Buttons
     * und Warnung weg – Zustand erneut anwenden. */
    try {
      var obs = new MutationObserver(function () {
        if (!lastBad.length) return;
        /* Zustand nach einem Re-Rendering der Cart-Section erneut anwenden.
         * WICHTIG: eigener Timer – ein wartendes checkCart() darf hier nicht
         * abgeraeumt werden, sonst loest sich eine Sperre nie wieder. */
        clearTimeout(applyTimer);
        applyTimer = setTimeout(applyBlock, 60);
        /* Zusaetzlich neu einlesen, falls die Mengenaenderung ueber einen Weg
         * lief, den die fetch-/XHR-Patches nicht sehen. */
        scheduleCheck(400);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* still */ }
  }

  /* ------------------------------------------------------------ Verdrahtung */

  function boot() {
    var box = initBox();
    var rates = box ? box.rates : null;

    if (box) {
      var sync = function () {
        var id = currentVariantId();
        if (id) box.render(id);
        applyMin(rates);
      };
      sync();
      guardSubmit(rates);
      ['variant:change', 'on:variant:change', 'change'].forEach(function (ev) {
        document.addEventListener(ev, sync, true);
      });
    }

    watchCart();
    checkCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
